import type { SxProps, Theme } from '@mui/material/styles';

export const tableSx: SxProps<Theme> = {
  '&.MuiTable-root': {
    width: 'max-content',
    // The global theme stretches every MUI table to 1480px on narrower screens, which would ignore column widths.
    minWidth: 0,
  },
};

export const tableHeadSx: SxProps<Theme> = {
  '& .MuiTableCell-root': {
    color: 'brand',
    fontSize: 14,
    fontWeight: 600,
    p: 0.5,
    backgroundColor: 'background.paper',
  },
  '& .MuiTableSortLabel-root': {
    maxWidth: '100%',
    color: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit',
  },
  '& .MuiTableSortLabel-icon': {
    color: 'inherit',
    fill: 'currentColor',
  },
};

export const headerLabelSx: SxProps<Theme> = {
  display: 'block',
};

const ellipsisSx = {
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const getCellContentSx = (width: string | number): SxProps<Theme> => ({
  width,
  ...ellipsisSx,
  '& *:not(svg, svg *)': ellipsisSx,
  '& svg': { flexShrink: 0 },
});

export const groupHeaderSx: SxProps<Theme> = {
  p: 0,
};

export const groupButtonSx: SxProps<Theme> = {
  color: 'brand',
  display: 'flex',
  justifyContent: 'flex-start',
  gap: 0.5,
  width: '100%',
  px: 0,
  py: 1,
  fontSize: 14,
  fontWeight: 600,
  textAlign: 'left',
};

export const groupLabelSx: SxProps<Theme> = {
  minWidth: 0,
  flexShrink: 1,
};

export const tailCellSx: SxProps<Theme> = {
  p: 0.5,
};

export const groupTailCellSx: SxProps<Theme> = {
  ...tailCellSx,
  pl: 4,
};

export const tailErrorSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const actionCellSx: SxProps<Theme> = {
  whiteSpace: 'nowrap',
  p: 0.5,
};
